export const GET_SIZES = "GET SIZES";